import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Alert } from "components/bootstrap";
const StyledList = styled.ul`
  padding: 0;
  margin: 0;
`;
const EntityList = ({ bsNoItemsStyle = void 0, items, noItemsText = void 0 }) => {
  const { t } = useTranslation("common");
  if (items.length === 0) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: bsNoItemsStyle }, noItemsText != null ? noItemsText : t("empty.no_items_available"));
  }
  return /* @__PURE__ */ React.createElement(StyledList, null, items);
};
export default EntityList;
